export default ({ get, checkStatus, toJSON }) => ({
  getOnSiteMessages: () =>
    get(`universe/v1/on_site_messages/published`)
      .then(checkStatus)
      .then(toJSON),
});
